<template>
  <AggregateSalesDashboard
    title="全作業 売上情報"
    eyebrow="All Work Sales"
    description="年間予定作業と臨時作業を横断で集計し、総売上の全体像をすぐ把握できるように再構成しました。上位カテゴリの偏りと月次推移を1画面で追える構成です。"
    :tabs="tabs"
    :theme="theme"
  />
</template>

<script>
import AggregateSalesDashboard from '@/components/aggregate/AggregateSalesDashboard.vue';
import {
  getAggregateTotalSalesByBuilding,
  getAggregateTotalSalesByBusinessClassification,
  getAggregateTotalSalesByCustomer,
  getAggregateTotalSalesByInCharge,
  getAggregateTotalSalesByMonth,
  getAggregateTotalSalesByVendor,
} from '@/api/axios';
import { createAggregateTabs } from '@/utils/aggregateDashboard';

const tabs = createAggregateTabs({
  buildingFetcher: getAggregateTotalSalesByBuilding,
  customerFetcher: getAggregateTotalSalesByCustomer,
  vendorFetcher: getAggregateTotalSalesByVendor,
  businessFetcher: getAggregateTotalSalesByBusinessClassification,
  inChargeFetcher: getAggregateTotalSalesByInCharge,
  monthFetcher: getAggregateTotalSalesByMonth,
});

const theme = {
  accent: '#b86a1c',
  accentSoft: '#ffedd8',
  accentStrong: '#8d5014',
  accentRgb: '184, 106, 28',
  surfaceAlt: '#fff8f1',
  border: '#eedcc8',
  textMuted: '#7a6858',
};

export default {
  name: 'TotalSalesByData',
  components: {
    AggregateSalesDashboard,
  },
  setup() {
    return {
      tabs,
      theme,
    };
  },
};
</script>
